import Chunk from 'nanogl-pbr/Chunk'
import ChunksSlots from 'nanogl-pbr/ChunksSlots'
import Input, { ShaderType, Uniform } from 'nanogl-pbr/Input'
import TexCoord from 'nanogl-pbr/TexCoord'

export default class GlowingEye extends Chunk {
  private uvs: Input
  private time: Input
  public timeUniform: Uniform

  // private spiral: Input;
  // public spiralUniform: Uniform;

  constructor() {
    super(true, false)

    this.addChild((this.uvs = new Input('TexCoord', 2, ShaderType.FRAGMENT)))
    this.addChild((this.time = new Input('Time', 1, ShaderType.FRAGMENT)))

    this.uvs.attachAttribute(TexCoord.create('aTexCoord0').attrib)
    this.timeUniform = this.time.attachUniform('uTime')

    // this.addChild(this.spiral = new Input('Spiral', 1, ShaderType.FRAGMENT));
    // this.spiralUniform = this.spiral.attachUniform('uSpiral');
  }

  _genCode(slots: ChunksSlots): void {
    slots.add(
      'postf',
      /*glsl*/ `
      
      vec2 uv = TexCoord() + vec2(0.0, 0.015);
      float len = length(uv - vec2(0.5));
      float sinus = sin(len * 10.0 - uTime * 1.5 + 1.2);

      float r = 0.065;
      float center = smoothstep(r + 0.001, r, len);

      float l1 = 0.995 - len * 0.01;
      float l2 = 0.995 - len * 0.01 + 0.001;
      float wave = smoothstep(l1, l2, sinus) + smoothstep(-l1, -l2, sinus);
      // float wave = step(0.995 - len * 0.01, sinus) + step(sinus, -0.995 + len * 0.01);

      // // Draw a spiral
      // float a = atan(uv.y - 0.5, uv.x - 0.5);
      // float d = len;

      // // Rotate the spiral
      // float p1 = cos(uTime * 0.5) * 0.5 + 0.5;
      // float p2 = sin(uTime * 0.5) * 0.5 + 0.5;
      // float phase = -uTime * 2.0;
      // float band = a * 2.0;
      // float distort = 20.0;
      // float spiral = step(0.5, abs(sin(band + d * distort + phase))) * step(0.5, abs(cos(band + d * distort + phase)));

      // float pattern = mix(wave, spiral, Spiral());
      float pattern = wave;

      FragColor.a = clamp(center + pattern, 0.0, 1.0);

      `
    )
  }
}
